import React from 'react'
import { colors } from 'pixel-base'

interface DCLogoProps {
  width?: number | string
  height?: number | string
  className?: string
  color?: string
}

const DCLogo: React.FC<DCLogoProps> = ({
  width = 24,
  height = 24,
  color = colors.primary,
  className = '',
}) => {
  return (
    <div style={{ width: 'auto', height: '30px' }}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 1000 1000"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        //   current-color="currentColor"
      >
        <circle
          cx="500"
          cy="500"
          r="450"
          stroke={color}
          strokeWidth="50"
          fill="white"
        />
        <path
          d="M642 250H750C750 250 800 250 800 300V700C800 700 800 750 750 750H550V650H700V350H550V250H642Z"
          fill={color}
        />
        <path
          d="M358 250H250C250 250 200 250 200 300V700C200 700 200 750 250 750H450V650H300V350H450V250H358Z"
          fill={color}
        />
      </svg>
    </div>
  )
}

export default DCLogo
